import { createAction } from 'typesafe-actions';
import { put, select, takeEvery } from 'redux-saga/effects';
import { getBaseEntityIdForTintService, getPriceOfTintService } from 'features/related-services';
import { CompareCategory, getCompareCategory, getProductBrand, getProductId } from 'features/product-info';
import { SELECT_COLOR_BUTTON_IS_IN_VIEWPORT } from 'features/product-info/ducks/product-tint-service';

/**
 * Cобытие должно срабатывать при попадании кнопки Выбрать цвет во viewport.
 *
 * @see https://tracker.yandex.ru/PCP-10342
 */
export const gaViewSelectTintService = createAction('GA:impressions')<{
  elementType: 'service';
  elementBlock: 'productDetail'; // блок, в котором расположен элемент
  elementName: 'outstoreServices';
  elementText: 'Выбрать цвет';
  productName: 'Услуга колеровки'; // название товара
  productId: string; // артикул услуги колеровки
  productParentId: string; // артикул товара, к которому применяется колеровка
  productPrice: string; // стоимость единицы товара (литра колеровки)
  productPosition: '1'; // позиция слева-направо и сверху-вниз от 1
  productBelong: 'LeroyMerlinServices'; // признак услуги
  category?: string;
  brand?: string;
}>();

function* putGaViewSelectTintService() {
  const idOfTintService: string | null = yield select(getBaseEntityIdForTintService);
  const productParentId: string | undefined = yield select(getProductId);
  const tintServicePrice: string = yield select(getPriceOfTintService);
  const brand = (yield select(getProductBrand)) as string;
  const compareCategory = (yield select(getCompareCategory)) as CompareCategory;

  yield put(
    gaViewSelectTintService({
      elementType: 'service',
      elementBlock: 'productDetail',
      elementName: 'outstoreServices',
      elementText: 'Выбрать цвет',
      productName: 'Услуга колеровки',
      productId: idOfTintService ? idOfTintService : '',
      productParentId: productParentId || '',
      productPrice: tintServicePrice.concat('.00'),
      productPosition: '1',
      productBelong: 'LeroyMerlinServices',
      brand,
      category: compareCategory?.name || '',
    }),
  );
}

export function* runGaViewSelectTintServiceDetector() {
  yield takeEvery(SELECT_COLOR_BUTTON_IS_IN_VIEWPORT, () => putGaViewSelectTintService());
}
